import axios from './axiosInstance';

const apiService = {
    getAll: async (endpoint, config = {}) => {
        const response = await axios.get(endpoint, config);
        return response.data.data;
    },

    getById: async (endpoint, id) => {
        const response = await axios.get(`${endpoint}/${id}`);
        return response.data.data;
    },

    create: async (endpoint, data) => {
        const isFormData = data instanceof FormData;

        const config = {
            headers: {
                'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
            }
        };

        try {
            const response = await axios.post(endpoint, isFormData ? data : JSON.stringify(data), config);

            if (!response.data) {
                throw new Error('Server returned empty response');
            }

            return response.data;
        } catch (error) {
            const apiError = new Error(error.response?.data?.message || error.message);
            console.log("apiError", apiError);
            apiError.response = error.response;
            throw apiError;
        }
    },

    update: async (endpoint, id, data) => {
        const response = await axios.put(`${endpoint}/${id}`, data);
        return response.data;
    },

    remove: async (endpoint, id) => {
        const response = await axios.delete(`${endpoint}/${id}`);
        return response.data;
    },

    get: async (url, config = {}) => {
        const response = await axios.get(url, config);
        return response.data;
    },

    post: async (url, data, config = {}) => {
        const response = await axios.post(url, data, config);
        return response.data;
    }
};

export default apiService;
